import script from "./CourtSessions.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtSessions.vue?vue&type=script&setup=true&lang=js"

import "./CourtSessions.vue?vue&type=style&index=0&id=502731fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502731fc"]])

export default __exports__